import React from "react";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Input from "../../../../components/inputs/inputs";
import Warning from "../../../../assets/images/icons/warning.svg";
import { searchRestaurantsAction } from "../../../../redux/restaurant/restaurantActions";
import restaurantType from "../../../../redux/restaurant/restaurantTypes";
import { searchAllStores } from "../../../../redux/stores/storeActions";
import storeType from "../../../../redux/stores/storeTypes";

export default function TransferOutlet({
  outletType,
  setOutletType,
  selectedoutlet,
  setSelectedOutlet,
  restaurantName,
  setRestaurantName,
  storeName,
  setStoreName,
}) {
  const dispatch = useDispatch();

  const { search } = useSelector((state) => state.restaurant);
  const { searchStore } = useSelector((state) => state.store);

  const handleSearchRestaurant = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setRestaurantName(value);
    if (value.length >= 3) {
      dispatch(
        searchRestaurantsAction({
          search: value,
        })
      );
    } else if (value.length <= 3) {
      dispatch({ type: restaurantType["SEARCH_RESTAURANT"], payLoad: [] });
      setSelectedOutlet({});
    }
  };

  function selectRestaurant(result) {
    setSelectedOutlet(result);
    setRestaurantName(result?.restaurant_name);
    var mydiv = document.getElementById(result.id);
    if (result.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }
    dispatch({ type: restaurantType["SEARCH_RESTAURANT"], payLoad: [] });
  }

  const handleSearchStore = (event) => {
    event.preventDefault();
    const { value } = event.target;
    setStoreName(value);
    if (value.length >= 3) {
      dispatch(
        searchAllStores({
          search: value,
        })
      );
    } else if (value.length <= 3) {
      dispatch({ type: storeType["SEARCH_STORES"], payLoad: [] });
    }
  };

  function selectStore(result) {
    setSelectedOutlet(result);
    setStoreName(result.store_name);
    var mydiv = document.getElementById(result.id);
    if (result.id) {
      mydiv.style.borderColor = "border-[#D14522]";
    }
    const searchStore = { data: [] };
    dispatch({ type: storeType["SEARCH_STORES"], payLoad: searchStore });
  }

  return (
    <>
      <div className="mx-auto bg-white dark:bg-[#121212] w-full p-6 ">
        <form>
          <div className="">
            <Input.Select
              title={"Select Restaurant or Store"}
              name="outletType"
              htmlFor={"outletType"}
              defaultValue={outletType}
              onChange={(e) => {
                setOutletType(e.target.value);
                setSelectedOutlet({});
                setRestaurantName("");
                setStoreName("");
              }}
            >
              <option>Select option</option>
              <option value={"restaurant"}>Restaurant</option>
              <option value={"store"}>Store</option>
            </Input.Select>
          </div>

          {outletType === "restaurant" && (
            <div>
              <Input.Label
                title={"Restaurant name"}
                type="text"
                name="restaurant_id"
                id="restaurant_id"
                value={restaurantName}
                className="w-full border border-[#E4E4F3] bg-[#F3F3F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="Enter restaurant name to search"
                onChange={handleSearchRestaurant}
              />

              {search &&
                Array.isArray(search) &&
                search?.map((result, index) => (
                  <div
                    className="p-3 border border-primary mb-2"
                    id={result.id}
                    key={index}
                    onClick={() => selectRestaurant(result)}
                  >
                    <div className=" grid-cols-3">
                      <div className="col-span-1">
                        <div className="">
                          <h6 className="text-sm font-meduim">
                            Name: {result.restaurant_name}
                          </h6>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div>
                          <h6 className="text-sm font-meduim">
                            Phone: {result.restaurant_phone}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}

          {outletType === "store" && (
            <div>
              <Input.Label
                title={"Store name"}
                type="text"
                name="store_id"
                id="store_id"
                value={storeName}
                className="w-full border border-[#E4E4F3] bg-[#F3F3F3] focus:border-primary focus:ring-0 sm:text-sm"
                placeholder="Enter store name to search"
                onChange={handleSearchStore}
              />

              {searchStore &&
                Array.isArray(searchStore) &&
                searchStore?.map((result, index) => (
                  <div
                    className="p-3 border border-primary mb-2"
                    id={result.id}
                    key={index}
                    onClick={() => selectStore(result)}
                  >
                    <div className=" grid-cols-3">
                      <div className="col-span-1">
                        <div className="">
                          <h6 className="text-sm font-meduim">
                            Name: {result.store_name}
                          </h6>
                        </div>
                      </div>
                      <div className="col-span-1">
                        <div>
                          <h6 className="text-sm font-meduim">
                            Phone: {result.store_phone}
                          </h6>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
            </div>
          )}
        </form>

        {/* Search Results */}
        <div>
          {outletType === "restaurant" &&
            restaurantName !== "" &&
            selectedoutlet?.restaurant_name && (
              <div className="border border-[#E4E4F3] dark:border-[#bcbcbc] bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
                <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
                  <h3 className="text-lg font-medium">Restaurant Details</h3>
                </div>

                <div className="grid grid-cols-2 gap-4 sm:gap-8 mt-6">
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Restaurant Name
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold">
                      {selectedoutlet?.restaurant_name}
                    </p>
                  </div>
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Restaurant Email
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold break-words">
                      {selectedoutlet?.restaurant_email}
                    </p>
                  </div>
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Created On
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold">
                      {moment(selectedoutlet?.created_at).format(
                        "DD, MM YYYY, hh:mm a"
                      )}
                    </p>
                  </div>
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Restaurant ID
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold">
                      {selectedoutlet?.id}
                    </p>
                  </div>
                </div>
              </div>
            )}

          {outletType === "store" &&
            storeName !== "" &&
            selectedoutlet?.store_name && (
              <div className="border border-[#E4E4F3] dark:border-[#bcbcbc] bg-white dark:bg-[#121212] rounded-md py-5 px-4 sm:px-8">
                <div className="border-b border-[#E4E4F3] py-3 flex justify-between items-center">
                  <h3 className="text-lg font-medium">Store Details</h3>
                </div>

                <div className="grid grid-cols-2 gap-4 sm:gap-8 mt-6">
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Store Name
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold">
                      {selectedoutlet?.store_name}
                    </p>
                  </div>
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Store Email
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold break-words">
                      {selectedoutlet?.store_email}
                    </p>
                  </div>
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Created On
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold">
                      {moment(selectedoutlet?.created_at).format(
                        "DD, MM YYYY, hh:mm a"
                      )}
                    </p>
                  </div>
                  <div>
                    <label className="text-[#9CA3AF] dark:text-[#BCBCBC] text-sm mb-2">
                      Store ID
                    </label>
                    <p className="text-[#151515] dark:text-white text-sm font-bold">
                      {selectedoutlet?.id}
                    </p>
                  </div>
                </div>
              </div>
            )}

          {/* Transfer caution notice */}
          {outletType !== "" &&
            (storeName !== "" || restaurantName !== "") &&
            (selectedoutlet?.restaurant_name || selectedoutlet?.store_name) && (
              <div className="mt-5 px-3 py-4 flex gap-4 items-center border border-primary">
                <img
                  src={Warning}
                  alt="warning"
                  className="w-[18px] h-[18px] cursor-pointer"
                />
                <p className="text-sm text-[#333333] dark:text-[#BCBCBC] font-medium">
                  Caution: Once ownership is transferred, this action cannot be
                  undone. Verify all details before confirming.
                </p>
              </div>
            )}
        </div>
      </div>
    </>
  );
}
